import { TranslationDictionary } from '@plandi/common'
import * as Yup from 'yup'

export const saveContactDetailsProfileSchema = (
  translate: TranslationDictionary['data']
) => {
  return Yup.object().shape({
    email: Yup.string().email(
      translate?.['wrong-email'] ?? 'Неправильный email'
    ),
    phone: Yup.string().matches(
      /[0-9]+$/,
      translate?.['phone-number-contain-10-digits'] ??
        'Номер телефона должен содержать код и 10 цифр'
    ),
    fullName: Yup.string(),
    avatarUrl: Yup.string()
  })
}
